import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import interviewConsentWithdrawn, {
	type InterviewConsentWithdrawnAction,
} from '@Application/Beneficiaries/Interviews/Actions/interviewConsentWithdrawn';
import interviewConsentWithdrawalFailed, {
	type InterviewConsentWithdrawalFailedAction,
} from '@Application/Beneficiaries/Interviews/Actions/interviewConsentWithdrawalFailed';
import type { InterviewConsentPayload } from '@Application/Beneficiaries/Interviews/Actions/interviewConsentFetched';
import type WithdrawInterviewConsent from '@Application/Beneficiaries/Interviews/Commands/WithdrawInterviewConsent';
import { del } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = InterviewConsentWithdrawnAction | InterviewConsentWithdrawalFailedAction;

/** Answers `200` with the withdrawn consent, not `204`: the body is typed, never `void`. */
export default (command: WithdrawInterviewConsent) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await del<InterviewConsentPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/interviews/${command.interviewId}/consent`,
			);

			const action = interviewConsentWithdrawn(
				payload,
				command.facilityId,
				command.subject.typeKey,
				command.subject.subjectId,
				command.interviewId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = interviewConsentWithdrawalFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
